/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import { fetchClosestAandE, fetchEmergencyContacts } from "../fetchData";

const EmergencyDetails = ({
  toast,
  isUploadInProgress,
  formValues,
  setFormValues,
}: any) => {
  const [closestAandEList, setClosestAandEList] = useState<any>([]);
  const [closestAandEListLoading, setClosestAandEListLoading] =
    useState<boolean>(false);
  const [emergencyContactsList, setEmergencyContactsList] = useState<any>(null);
  const [emergencyContactsListLoading, setEmergencyContactsListLoading] =
    useState<boolean>(false);

  useEffect(() => {
    fetchClosestAandE(setClosestAandEList, setClosestAandEListLoading, toast);
    fetchEmergencyContacts(
      setEmergencyContactsList,
      setEmergencyContactsListLoading,
      toast
    );
  }, []);

  const emergencyContactOptionsTemplate = (option: any) => {
    return (
      <div className="tw-flex tw-gap-2 tw-items-center">
        {option?.name} - {option?.contact}
      </div>
    );
  };

  const emergencyContactValueTemplate = (option: any) => {
    if (!option) {
      return <span>{formValues?.name || "Select Emergency Contact"}</span>;
    }

    return (
      <div className="tw-flex tw-gap-2 tw-items-center">
        {option?.name} - {option?.contact}
      </div>
    );
  };

  return (
    <>
      <div className=" tw-flex  tw-gap-4 tw-items-center tw-flex-wrap">
        <div className="tw-p-4 tw-flex tw-flex-col tw-gap-4">
          <div className="tw-flex  tw-gap-2 tw-justify-between xl:tw-flex-row tw-flex-col lg:tw-max-w-[380px]">
            <label className="leak-label lg:tw-w-[220px]">
              Is a First Aider available on site
            </label>
            <div className="tw-flex-row tw-flex tw-gap-2">
              <div className="tw-flex tw-gap-2">
                <RadioButton
                  inputId="yes"
                  name="emergency"
                  disabled={isUploadInProgress}
                  checked={
                    formValues?.emergencyDetails?.isFirstAiderAvailable === true
                      ? true
                      : false
                  }
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      emergencyDetails: {
                        ...prev.emergencyDetails,
                        isFirstAiderAvailable: true,
                      },
                    }));
                  }}
                />
                <label
                  htmlFor="yes"
                  className="tw-text-base tw-font-normal tw-text-[#101828]"
                >
                  Yes
                </label>
              </div>
              <div className="tw-flex tw-gap-2">
                <RadioButton
                  inputId="no"
                  name="emergency"
                  checked={
                    formValues?.emergencyDetails?.isFirstAiderAvailable ===
                    false
                      ? true
                      : false
                  }
                  disabled={isUploadInProgress}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      emergencyDetails: {
                        ...prev.emergencyDetails,
                        isFirstAiderAvailable: false,
                      },
                    }));
                  }}
                />
                <label
                  htmlFor="yes"
                  className="tw-text-base tw-font-normal tw-text-[#101828]"
                >
                  No
                </label>
              </div>
            </div>
          </div>
          <div className="tw-flex  tw-gap-2 tw-justify-between xl:tw-flex-row tw-flex-col lg:tw-max-w-[380px]">
            <label className="leak-label tw-w-[220px]">
              Is a first aid kit available on site
            </label>
            <div className="tw-flex-row tw-flex tw-gap-2">
              <div className="tw-flex tw-gap-2">
                <RadioButton
                  inputId="yes"
                  name="emergency"
                  checked={
                    formValues?.emergencyDetails?.isFirstAidKitAvailable ===
                    true
                      ? true
                      : false
                  }
                  disabled={isUploadInProgress}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      emergencyDetails: {
                        ...prev.emergencyDetails,
                        isFirstAidKitAvailable: true,
                      },
                    }));
                  }}
                />
                <label
                  htmlFor="yes"
                  className="tw-text-base tw-font-normal tw-text-[#101828]"
                >
                  Yes
                </label>
              </div>
              <div className="tw-flex tw-gap-2">
                <RadioButton
                  inputId="no"
                  name="emergency"
                  checked={
                    formValues?.emergencyDetails?.isFirstAidKitAvailable ===
                    false
                      ? true
                      : false
                  }
                  disabled={isUploadInProgress}
                  onChange={(e) => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      emergencyDetails: {
                        ...prev.emergencyDetails,
                        isFirstAidKitAvailable: false,
                      },
                    }));
                  }}
                />
                <label
                  htmlFor="yes"
                  className="tw-text-base tw-font-normal tw-text-[#101828]"
                >
                  No
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit">
          <label className="leak-label" htmlFor="teamMember1">
            {" "}
            Closest A&E
          </label>
          <Dropdown
            id="teamMember1"
            optionLabel="name"
            placeholder="Select Closest A&E"
            value={formValues?.emergencyDetails?.aAndE ?? ""}
            disabled={isUploadInProgress}
            loading={closestAandEListLoading}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                emergencyDetails: {
                  ...prev.emergencyDetails,
                  aAndE: e.value,
                },
              }));
            }}
            options={closestAandEList}
            filter
            className="custome-dropdown"
          />
        </div>
        <div className="tw-flex tw-flex-col tw-gap-1 tw-w-full md:tw-w-fit">
          <label className="leak-label" htmlFor="teamMember1">
            {" "}
            Details of Emergency Contact
          </label>
          <Dropdown
            id="teamMember1"
            optionLabel="name"
            placeholder="Select Emergency Contact"
            valueTemplate={emergencyContactValueTemplate}
            itemTemplate={emergencyContactOptionsTemplate}
            value={formValues?.emergencyDetails?.emergencyContact ?? ""}
            disabled={isUploadInProgress}
            loading={emergencyContactsListLoading}
            onChange={(e) => {
              setFormValues((prev: any) => ({
                ...prev,
                emergencyDetails: {
                  ...prev.emergencyDetails,
                  emergencyContact: e.value,
                },
              }));
            }}
            options={emergencyContactsList}
            filter
            className="custome-dropdown"
          />
        </div>
      </div>
    </>
  );
};

export default EmergencyDetails;
